<template>
  <div class="rounded bg-white outline outline-1 overflow-hidden relative outline-baby-blue w-48 h-40 cursor-pointer">
    <div class="relative w-8 h-8">
      <img
        :src="$asset('img/cancellation/signature-pencil.svg')"
        class="absolute top-2 left-2 scribble"
        :alt="$t('messages_nl.partials.letter.signature.altImage')"
        width="30"
        height="30"
        loading="lazy"
      >
      <img
        :src="$asset('img/cancellation/signature-box.svg')"
        class="absolute top-2 left-2"
        :alt="$t('messages_nl.partials.letter.signature.altImage')"
        width="30"
        height="30"
        loading="lazy"
      >
    </div>

    <div class="absolute left-0 right-0 top-0 bottom-0 p-2 flex justify-center items-center">
      <img
        id="signature-image"
        class="max-w-full max-h-full m-auto"
        :alt="$t('messages_nl.partials.letter.signature.fieldName')"
        :src="signature"
        height="190"
        width="160"
        loading="lazy"
      >
    </div>
  </div>
</template>

<script>
const EMPTY_ALT = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==';
export default {
  name: 'adivare-signature',
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    signature() {
      return this.$store.getters.getFormField('customerSignature') ?? EMPTY_ALT;
    },
  },
}
</script>
